import {Component, isDevMode, OnInit, ViewChild} from '@angular/core';
import {AppComponent} from '../../app.component';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {RouterService} from '../../service/RouterService';
import { BlockService } from '../../service/BlockService';
import {O2TourService} from '../../o2-tour';
import {Guide} from '../../mock/Guide';
import {environment} from "../../../environments/environment";
import {environment as preprod} from "../../../environments/environment.preprod";
import {environment as prod} from "../../../environments/environment.prod";
import {environment as prodext} from "../../../environments/environment.prod-ext";
import {MatDialog} from '@angular/material';
import {ModalUserGuideComponent} from '../user-guide/user-guide.component';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {
  envs = {"local": environment, "preprod": preprod, "prod": prod, "prod-ext": prodext};
  roles : any[] = [{id: -1,
    libelle: "ROLE DEFAULT",
    matricule: "",
    role: "ROLE_DEFAULT_MYSHIFT",
    project: "SITE_DEFAULT_MYSHIFT"
  }];

  public _env: string = environment.name;
  public roleSelected: string = "DEFAULT";
  public _envEnable: boolean = isDevMode();
  //  public date = new Date();
  public iconSwitchInterface = 'tune';
  public languages = {
    en: {
      name: 'English',
      code: 'en',
      flag: './assets/imgs/226-united-states.svg'
    },
    fr: {
      name: 'French',
      code: 'fr',
      flag: './assets/imgs/195-france.svg'
    },
    pt: {
      name: 'Portuguese',
      code: 'pt',
      flag: './assets/imgs/224-portugal.svg'
    },
    es: {
      name: 'Espagnol',
      code: 'es',
      flag: './assets/imgs/224-portugal.svg'
    },
    tr: {
      name: 'Turkish',
      code: 'tr',
      flag: './assets/imgs/turkey.svg'
    },
    de: {
      name: 'German',
      code: 'de',
      flag: './assets/imgs/germany.svg'
    }
  };

  constructor(private route: Router,
              private rs: RouterService,
              private app: AppComponent,
              public dialog: MatDialog,
              private translate: TranslateService,
              private blockservice: BlockService) {
    this.iconSwitchInterface = this.switchIcon(this.rs.GetURI());
  }

  // Pipe (Format Date)
  get format()   { return this.translate.currentLang === 'fr' ? 'EEE dd MMM' : 'EEE dd MMM'; }

  ngOnInit() {
    let matricule = JSON.parse(localStorage.getItem(environment.oauth.remoteUser)).userName;
    this.ChangeEnv('local');
    this.getRoles(matricule);
    this.roleSelected = !localStorage.getItem("ROLE_SELECTED") || localStorage.getItem("ROLE_SELECTED") == 'null'?"DEFAULT":localStorage.getItem("ROLE_SELECTED");
  }

  toggleRightSidenav() {
    this.app.sidenav.toggle();
  }

  ChangeLang(code) {
    console.log('ChangeLang', code);
    this.translate.use(code);
  }

  getCurrentLang(){
    return this.translate.currentLang;
  }

  _guideLabel = "All about";
  downloadPdfFile(guideType:string){
    this._guideLabel = guideType;
    //this.blockservice.saveFile(guideType);
  }

  public toConfigs() {
    if ( ['/events', '/'].indexOf(this.rs.GetURI()) > -1 ) {
        this.route.navigateByUrl('/params');
      } else {
        this.route.navigateByUrl('/events');
      }
    this.iconSwitchInterface = this.switchIcon(this.rs.GetURI());

  }

  public switchIcon(url) {
    return (['/events', '/'].indexOf(url) === -1 ? 'tune' : 'home');
  }
  startGuide() {
    this.rs.setShowGuide(true);
  }
  test() {
  }

  ChangeEnv(env) {
    const envs = {"local": environment, "preprod": preprod, "prod": prod, "prod-ext": prodext};
    this._env = env;
    Object.keys(environment).forEach((k) => {
      environment[k] = envs[env][k];
    })
  }
  changeRole(roleDetails: any) {
    localStorage.clear();
    if (roleDetails.role.includes("ROLE_DEFAULT_MYSHIFT")){
      this.roleSelected = roleDetails.libelle;
      localStorage.setItem("ROLE", "ROLE_DEFAULT_MYSHIFT");
      localStorage.setItem("ROLE_SELECTED", this.roleSelected);
    }else{
      this.roleSelected = roleDetails.libelle;
      let roleSplite = roleDetails.role.split(",");
      let sitesSplite = roleDetails.project.split(",");
      let rolesUserConnected : any;
      let siteUserConnected : any;
      if (!localStorage.getItem("ROLE") || localStorage.getItem("ROLE") == 'null')
      {
        rolesUserConnected = [];
        siteUserConnected = [];
      }
      else {
        rolesUserConnected = localStorage.getItem("ROLE").split(",");
        siteUserConnected = localStorage.getItem("SITES").split(",");
      }
      roleSplite.forEach(role=> {
        if (rolesUserConnected && !rolesUserConnected.includes(role))
          rolesUserConnected.push(role);
      })

      sitesSplite.forEach(site=> {
        if (siteUserConnected && !siteUserConnected.includes(site))
          siteUserConnected.push(site);
      })

      localStorage.setItem("ROLE", rolesUserConnected);
      localStorage.setItem("SITES", siteUserConnected);
      localStorage.setItem("ROLE_SELECTED", this.roleSelected);
    }

//    window.location.reload();
    window.location.href = "/";
  }
  private getRoles(matricul: any) {
    this.blockservice.getRoles(matricul).subscribe(roles=> {
      roles.forEach(role => this.roles.push(role));
    });
  }

  openUserGuide() {
    this.dialog.open(ModalUserGuideComponent, {
      data: "data",
      panelClass: 'cdk-modal-injection',
    });  }
}



// WEBPACK FOOTER //
// ./src/app/layout/toolbar/toolbar.component.ts